import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Wifi = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.0481 11.912C2.4781 7.28203 6.2081 3.47203 10.8281 2.95203C16.8681 2.26203 21.9981 6.97203 21.9981 12.882C21.9981 16.182 20.3981 19.102 17.9281 20.922C17.4481 21.272 16.7681 21.132 16.4681 20.612C16.2181 20.172 16.3281 19.622 16.7281 19.322C18.7081 17.862 19.9981 15.532 19.9981 12.882C19.9981 8.16203 15.9081 4.39203 11.0881 4.94203C7.5681 5.33203 4.6481 8.12203 4.1081 11.622C3.6181 14.772 4.9881 17.632 7.2681 19.322C7.6681 19.622 7.7781 20.182 7.5281 20.612C7.2281 21.122 6.5481 21.272 6.0681 20.922C3.3681 18.932 1.6981 15.612 2.0481 11.912ZM17.9981 12.882C17.9981 9.32203 14.8881 6.48203 11.2481 6.93203C8.6281 7.25203 6.4681 9.34203 6.0681 11.952C5.7381 14.102 6.5581 16.062 7.9981 17.352C8.4781 17.782 9.2281 17.682 9.5581 17.122L9.5681 17.112C9.8081 16.692 9.7081 16.182 9.3481 15.852C8.3181 14.922 7.7581 13.482 8.1281 11.912C8.4581 10.492 9.6081 9.34203 11.0281 9.00203C13.6481 8.37203 15.9981 10.352 15.9981 12.882C15.9981 14.062 15.4781 15.112 14.6681 15.842C14.3081 16.162 14.1981 16.682 14.4381 17.102L14.4481 17.112C14.7581 17.642 15.4781 17.802 15.9481 17.392C17.1981 16.292 17.9981 14.682 17.9981 12.882ZM11.9981 10.882C10.8981 10.882 9.9981 11.782 9.9981 12.882C9.9981 13.982 10.8981 14.882 11.9981 14.882C13.0981 14.882 13.9981 13.982 13.9981 12.882C13.9981 11.782 13.0981 10.882 11.9981 10.882Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Wifi;
